import {
  Autocomplete,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOneAddIndex,
  setAddedIndexesFilterToggle,
  setAddedIndexesInit,
  setAddedIndexesId,
  setAddedIndexesName,
  setAddedIndexesOrder,
  setAddedIndexesPeriodOfTime,
  setAddedIndexesShortTerm,
  setAddedIndexesSummerizeOptions,
  setAddedIndexesTemporalMethod,
  setAddedIndexesWindow,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  setAddedIndexesFromDate,
  setAddedIndexesToDate,
} from "../../reducers/MonitoringSlice";
import CustomCheckBox from "./CustomCheckBox";
import YearPickerNormal from "./YearPickerNormal";
import { DateRangePicker } from 'react-date-range'; // Import react-date-range
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Popover } from '@mui/material';
import { formatDateDisplay } from "../../utils/date";
import { getIndexYearAvailableFrom, getIndexYearAvailableTo } from "../../utils/available_dates";

const HistoricalData = ({ isSingleIndex, requestSource, indexes }) => {
  const dispatch = useDispatch();

  // Add state for date picker popovers
  const [addedIndexPickerAnchors, setAddedIndexPickerAnchors] = useState([]);

  const formatDisplayDateRange = (fromDate, toDate) => {
    if (fromDate && toDate) {
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);
      const startStr = formatDateDisplay(startDate);
      const endStr = formatDateDisplay(endDate);
      return startDate.getTime() === endDate.getTime() ? startStr : `${startStr} - ${endStr}`;
    }
    return "Select Date Range";
  };

  const addedIndexes = useSelector((state) => state.monitoringState.addedIndexes);

  // Added getDateRange function (similar to Prediction/MainIndex.jsx)
  const getDateRange = (indexId) => {
    if (!indexId) return [];
    try {
      const indices = JSON.parse(localStorage.getItem("categories")) || [];
      const currentIndex = indices.find((index) => index.id === indexId);
      if (currentIndex && currentIndex.available_from && currentIndex.available_to && (currentIndex.available_from !== "None" && currentIndex.available_to !== "None")) {
        // Return dates without time
        const fromDate = new Date(currentIndex.available_from);
        const toDate = new Date(currentIndex.available_to);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);
        return [fromDate, toDate];
      }
    } catch (error) {
      console.error("Error parsing indices from localStorage:", error);
    }
    return []; // Return empty array if not found or error occurs
  };

  // Helper function to get default date range for added indexes
  const getDefaultDateRange = (indexId) => {
    const dateRange = getDateRange(indexId);
    if (dateRange.length === 2) {
      return {
        // CHANGE: Use the last available date (toDate) as default instead of first
        startDate: dateRange[1], // Use available to date as start
        endDate: dateRange[1]    // Use available to date as end
      };
    }
    // Fallback to current date if no range available
    const currentDate = new Date();
    return {
      startDate: currentDate,
      endDate: currentDate
    };
  };

  const pageTitle = isSingleIndex ? addedIndexes[0].name.toUpperCase() : requestSource.toUpperCase();

  const handleToggleFilter = (index) => {
    dispatch(setAddedIndexesFilterToggle({ index: index }));
  };

  return (
    <div style={{ width: "60%" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography fontWeight={500} fontSize={30}>
          {pageTitle}
        </Typography>
      </div>
      <br />

      {/* all indexes monitoring index */}
      <div>
        {addedIndexes.map((added, addedIndex) => {
          const defaultRange = getDefaultDateRange(added.id);
          const indexYearAvailableFrom = getIndexYearAvailableFrom(added.id, 1900)
          const indexYearAvailableTo = getIndexYearAvailableTo(added.id, new Date().getFullYear())

          return (
            <div key={added.uid}>
              {addedIndex > 0 && (
                <Divider sx={{ marginY: '30px', '&::before, &::after': { borderColor: 'rgba(0, 0, 0, 0.2)' } }} />
              )}
              {!isSingleIndex && (
                <>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography fontWeight={600}>Choose Index</Typography>
                  </div>
                  <br />
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    isOptionEqualToValue={(option, value) =>
                      option.name === value.name
                    }
                    getOptionLabel={(option) => (option ? option.name : "")}
                    onChange={(_, selected) => {
                      if (selected) {
                        console.log("selected", selected);
                        dispatch(setAddedIndexesId({ index: addedIndex, id: selected.id }));
                        dispatch(
                          setAddedIndexesName({
                            index: addedIndex,
                            name: selected.key,
                          })
                        );
                      }
                    }}
                    options={indexes || []}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField {...params} label="Index" required />
                    )}
                    value={added.name ? indexes.find(idx => idx.key === added.name) || null : null}
                  />
                  <br />
                </>
              )}
              <div>
                <>
                  <div>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={added.filterToggle ?? (addedIndexes[0]?.filterToggle || false)}
                          onChange={() => handleToggleFilter(addedIndex)}
                          color="primary"
                        />
                      }
                      label="Do you want to use Filtering ?"
                    />
                    <br />
                    {added.filterToggle && (
                      <div>
                        <label>Days (minimum 3)</label>
                        <br />

                        <TextField
                          onChange={(event) => {
                            const value = parseInt(event.target.value);
                            if (value >= 3) {
                            dispatch(
                              setAddedIndexesWindow({
                                index: addedIndex,
                                  window: event.target.value,
                              })
                            );
                            }
                          }}
                          size="small"
                          value={added.window || 10}
                          type="number"
                          inputProps={{ min: 3 }}
                        />
                        <br />
                        <br />
                        <label>Order (minimum 1, must be less than days)</label>
                        <br />

                        <TextField
                          onChange={(event) => {
                            const value = parseInt(event.target.value);
                            const windowValue = parseInt(added.window) || 10;
                            if (value >= 1 && value < windowValue) {
                            dispatch(
                              setAddedIndexesOrder({
                                index: addedIndex,
                                  order: event.target.value,
                              })
                            );
                            }
                          }}
                          size="small"
                          value={added.order || 2}
                          type="number"
                          inputProps={{ min: 1, max: (parseInt(added.window) || 10) - 1 }}
                        />
                      </div>
                    )}
                    <br />
                  </div>
                  <div>
                    <Typography>Select Range</Typography>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="normal"
                      disabled={!added.id || getDateRange(added.id).length === 0}
                      value={formatDisplayDateRange(added.from_date, added.to_date)}
                      onClick={(event) => {
                        if (added.name) {
                          const newAnchors = [...addedIndexPickerAnchors];
                          newAnchors[addedIndex] = event.currentTarget;
                          setAddedIndexPickerAnchors(newAnchors);
                        }
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      placeholder={added.name && getDateRange(added.name).length > 0 ?
                        `Available: ${formatDateDisplay(getDateRange(added.name)[0])} - ${formatDateDisplay(getDateRange(added.name)[1])}` :
                        "Select an index first"
                      }
                    />
                    <Popover
                      open={Boolean(addedIndexPickerAnchors[addedIndex])}
                      anchorEl={addedIndexPickerAnchors[addedIndex]}
                      onClose={() => {
                        const newAnchors = [...addedIndexPickerAnchors];
                        newAnchors[addedIndex] = null;
                        setAddedIndexPickerAnchors(newAnchors);
                      }}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <DateRangePicker
                        staticRanges={[]}
                        ranges={[{
                          startDate: added.from_date ? new Date(added.from_date) : defaultRange.startDate,
                          endDate: added.to_date ? new Date(added.to_date) : defaultRange.endDate,
                          key: 'selection'
                        }]}
                        onChange={(item) => {
                          if (!item.selection || !item.selection.startDate || !item.selection.endDate) {
                            return;
                          }
                          const fromDate = new Date(item.selection.startDate);
                          const toDate = new Date(item.selection.endDate);
                          fromDate.setHours(12, 0, 0, 0);
                          toDate.setHours(12, 0, 0, 0);

                          dispatch(
                            setAddedIndexesFromDate({
                              index: addedIndex,
                              fromDate: fromDate.toISOString().split("T")[0]
                            })
                          );
                          dispatch(
                            setAddedIndexesToDate({
                              index: addedIndex,
                              toDate: toDate.toISOString().split("T")[0]
                            })
                          );
                        }}

                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={1}
                        direction="horizontal"
                        editableDateInputs={false}
                        minDate={getDateRange(added.id)[0] || undefined}
                        maxDate={getDateRange(added.id)[1] || undefined}
                      />
                    </Popover>
                    {!added.name && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '4px' }}>
                        Please select an index first to enable date selection.
                      </Typography>
                    )}
                  </div>
                </>
                <br />
                <div>
                  <CustomCheckBox
                    title={"Time-step"}
                    data={added.periodOfTime}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesPeriodOfTime}
                    index={addedIndex}
                  />
                  <br />
                  <CustomCheckBox
                    title={"Temporal Method"}
                    data={added.temporalMethod}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesTemporalMethod}
                    index={addedIndex}
                  />
                  <br />
                  <CustomCheckBox
                    title={
                      (added.temporalMethod?.find(
                        (option) => option.key === "pixel" && option.checked
                      ))
                        ? "Spatial Stats"
                        : "Temporal Stats"
                    }
                    data={added.summerizeOptions}
                    dispatch={dispatch}
                    reduxFunc={setAddedIndexesSummerizeOptions}
                    index={addedIndex}
                  />
                  <br />
                  <div style={{ width: "100%" }}>
                    <Typography>Select Historical Years</Typography>
                    <br />
                    <div style={{ display: "flex", gap: "4%" }}>
                      <div style={{ width: "48%" }}>
                        <YearPickerNormal
                          style={{ width: "100%" }}
                          setYear={(value) => dispatch(setAddedIndexesYearFrom({ index: addedIndex, yearFrom: value }))}
                          yearFrom={indexYearAvailableFrom}
                          yearTo={added.historicalYearTo || indexYearAvailableTo}
                          label="Year From"
                          defValue={added.historicalYearFrom}
                        />
                      </div>
                      <div style={{ width: "48%" }}>
                        <YearPickerNormal
                          style={{ width: "100%" }}
                          setYear={(value) => dispatch(setAddedIndexesYearTo({ index: addedIndex, yearTo: value }))}
                          yearFrom={added.historicalYearFrom || indexYearAvailableFrom}
                          yearTo={indexYearAvailableTo}
                          label="Year To"
                          defValue={added.historicalYearTo}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div style={{ width: "100%" }}>
                    <Typography>Select Short-term Year (should be within historical years range)</Typography>
                    <br />
                    <div style={{ width: "100%" }}>
                      <YearPickerNormal
                        style={{ width: "100%" }}
                        setYear={(value) => dispatch(setAddedIndexesShortTerm({ index: addedIndex, short: value }))}
                        yearFrom={added.historicalYearFrom || indexYearAvailableFrom}
                        yearTo={added.historicalYearTo || indexYearAvailableTo}
                        defValue={added.shortTermMonitoring}
                      />
                    </div>

                    <br />
                    <br />
                  </div>

                </div>
              </div>
              <br />
              {!isSingleIndex && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    dispatch(deleteOneAddIndex({ index: addedIndex }));
                  }}
                >
                  Delete this index
                </Button>
              )}
              <br />
              <br />
            </div>
          );
        })}
        {!isSingleIndex && (
          <Button fullWidth variant="outlined" onClick={() => {dispatch(setAddedIndexesInit())}}>
            {addedIndexes.length > 0 ? "Add another index" : "Add Index"}
          </Button>
        )}
      </div>
    </div >
  );
};

export default HistoricalData;
